import { useAccount } from '../account/AccountContext.tsx';

// Shop-focused views of the account context.
export function useMyShops() {
  const { status, shops, invites, refresh } = useAccount();
  return { status, shops, invites, refresh };
}

export function useMyShopRole(shopId: string | null | undefined) {
  const { shops } = useAccount();
  return shops.find(shop => shop.shopId === shopId)?.role ?? null;
}

export function shopPath(shop: { handle: string | null; shopId?: string; id?: string }) {
  return `/s/${encodeURIComponent(shop.handle || shop.shopId || shop.id || '')}`;
}
